import "./NavPost.css";
import { Link } from 'react-router-dom';
import RecommendedPosts from '../Pages/Shuffle';
import handleShuffle from '../Pages/Shuffle';
import SocialMediaSignup from '../SignupLoginModal/SocialMediaSignup';
import LogoNavHome from '../Pages/NavBarHomeImg/logoNavHome.png';
import basil from '../image/basil.jpg';




  const NavPost = () =>{

      let text=document.getElementsByClassName('text')

      const itemClicked = (event) => {
        event.stopPropagation();
    }
        const allClicked = (event) => {
            text[0].innerText="No notifications yet";
            event.stopPropagation();
        }
        const MentionsClicked = (event) => {
          text[0].innerText="No mentions yet";
          event.stopPropagation();
        }
        
        
      return(
       

        <div className='basic-navbar sticky-top'>
          <div className='components'>
                <div className='left-components'>   
                        <div id="menu-divP">
                        <button className="btn-start" type="button" data-bs-toggle="offcanvas" 
                            data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling" ><img className="menue"src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAH9JREFUWEft1UsKgDAMANH05npypTsXtYOGQAvTbaikLx9bLHbaYvmECVFFFFKIBCi+VQ9d9JpkfIgxEzKhLr5VDyVb5N91hchtJnREROWknaPkHPuHyufF2EtWeYbfd8qIXKGMUOUOev2Puocye4jKXRJ3yohVIYVIgOL2EAndFg4LJcntgd8AAAAASUVORK5CYII="/></button>
                        </div>  
                        <div className='logo-div'>
                            <Link to='/Home' className="navbar-brand" href="#" ><img id="gag-imgP" src={LogoNavHome} /></Link>
                        </div>
                        
                            <Link to='/shuffle' className="left-links" id='ShuffleP' onClick={RecommendedPosts}><b>🔀 Shuffle</b></Link>
                            <Link to='/getapp' className="left-links" id='GetAppP'><b>📱 Get App</b></Link>
                            <a className="left-links" id='MemelandP'><b>🏴‍☠️ Memeland</b></a>
                            <a className="left-links" id='PotatozP'><b>🥔 Potatoz</b></a>
                        
                  </div>  
                  <div className='right-componentsP'>
                   <div className="dropdown" id='fsearch-divP' >
                       <button id="search-butP" className="btn btn-secondary " type="button" data-bs-toggle="dropdown" aria-expanded="false" > 
                           <img id="search-iconP" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAjRJREFUSEv
                               lllFO20AQhme8m742nKDpCRoeKxwgUnYl3sIJCjegJyCcoPQEDScgb0g2UqAE9ZHcoOEEmFds71RrOZEdbO86kssD+xIpmp1vZv6ZWSO80cE34oI1+M739
                               4Hoi4PYVkQBAcx3pbzdNPBK8J+rq07cap0C0VEJIADECQvDs68HB4s6QZSCZ75/AgA/bJ0R0UlPyp+29oXgmeeNAfHbygnRhXKcSczYTb/fD6bTaZvF8b6
                               j1DBnhzh2B4NjG/gr8Fqmj0g03JFyXubs3vO6hDgBgE+pzXdXiHMTPAdONOX8b3rpMeS8qzM0OdEVaEWRDi6Bsyj6bNI8B86WGIm2qzJdDybN/CH5n+jCl
                               bKsIROTPNj3yfZiURUygQeuEFtVlVqB9ZwiwFQbK8TD3cFA61br/L6+HjpEl0nSAP2eEDdlDlbgbFOFnG/ZaLvuNNX6yabJshmPEOBUX3KFsN5o6/BZKhc
                               BnPWEGP33jE1yNaaxaSpyJb3z/QABPtqMg6GrjXI1MscmfV/NcW5zIS5CxrZtujvp5jh+AKIOATxHnHdM96p3NeIClTo07mrHudTQOsvH7nVCHCPR5IXz2
                               +Xr9CGK9ghxWPRWI9HxjpRjq81VMI/W77Eurw4s+0Sa4OYvEMZGOrOk2wuObqSI83NdiXvPOyLEX0uzKrj1hkp3eZcA2oQ4Z0otirS3hVuD67wWNvBGwDr
                               ILLyo5I2Bl3D9W9ThjYI3Gqc6mm5i+/4y/gdaBUkuj2W3yQAAAABJRU5ErkJggg=="/>
                       </button>
                           <ul id="search-drpdownP" className="dropdown-menu">
                                   <li>
                                   <nav className="navbar navbar-light bg-light">
                                       <form className="form-inline">
                                       <div className="input-group">
                                           <div id="search-div" className="input-group-prepend">
                                           <span className="input-group-text" id="basic-addon1P"><svg id="nested-searchP" xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                               <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                           </svg></span>
                                           </div>
                                           <input id="search-inputP" type="text" className="form-control" placeholder="Search..." aria-label="Username" aria-describedby="basic-addon1"  />
                                       </div>
                                       </form> 
                                   </nav> 
                                   </li>    
                           </ul>
                   </div>  
                   <div className="dropdown-center">
                          <button id="notification-but" type="button" className="btn btn-secondary" data-bs-toggle="dropdown" aria-expanded="false" > 
                              <svg id="notification-img" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" className="bi bi-bell-fill" viewBox="0 0 16 16">
                              <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
                              </svg>
                          </button>
               
                          <ul  id="notification-dropdown" className="dropdown-menu">
                              <div className="buttons-div">  
                                  <button id="All" className="buttonss"  onClick={allClicked} > All</button>
                                  <button id="Mentions" className="buttonss" onClick={MentionsClicked}> Mentions</button>
                              </div>
                              <div className="text-div" >   
                                <b className="text">No notifications yet</b>
                              </div>
                          </ul>
                  </div>

                  <div id='profile-dropdownP' className="right-component dropdown-center">
                                <button id='profile-btnP' className="btn btn-secondary " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                  <img id="profP" src={basil} />     
                                </button>
                                <ul id='pofile-ulP' className="dropdown-menu">
                                    <li><a className="items dropdown-item">Sign up or Log in</a></li>
                                    <li><a className="items dropdown-item">Customize with Tags</a></li>
                                    <li><a className="items dropdown-item">Saved</a></li>
                                    <li><a className="items dropdown-item">Setting</a></li>

                                    <li>
                                        <a  className="items dropdown-item" onClick={itemClicked}> <div id="dark-mode-textP">Dark Mode<div id="dark-mode-switchP"  className="form-check form-switch">
                                           <input  className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
                                           <label className="form-check-label" htmlFor="flexSwitchCheckDefault"></label></div> </div>
                                        </a>
                                    </li>
                                    <li><a className="items dropdown-item">Download 9GAG App</a></li>
                                    <li><a className="items dropdown-item">Help Center</a></li>
                                    <li><a className="items dropdown-item">Report Problems</a></li>
                                    <li>
                                        <div className="accordion" >
                                                <div>
                                                    <h2 className="accordion-header" >
                                                    <button id="TermsP" className="accordion-button items" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne1P" aria-expanded="true" aria-controls="collapseOne" onClick={itemClicked}>
                                                    Terms & Policies
                                                    </button>
                                                    </h2>
                                                    <div id="collapseOne1P" className="accordion">
                                                    <div className="accordion-body AB">
                                                        <li className="nested-dropdpwn-items">Terms</li>
                                                        <li className="nested-dropdpwn-items">Privacy</li>
                                                        <li className="nested-dropdpwn-items">Copyright</li>
                                                        <hr className="nested-dropdpwn-hr"/>
                                                    </div>
                                                    </div>
                                                </div>
                                        </div>
                                        </li>



                                        <li>
                                        <div className="accordion" >
                                                <div>
                                                    <h2 className="accordion-header" >
                                                    <button id="AdvertiseP" className="accordion-button items " type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne2P" aria-expanded="true" aria-controls="collapseOne" onClick={itemClicked}>
                                                    Advertise
                                                    </button>
                                                    </h2>
                                                    <div id="collapseOne2P" className="accordion">
                                                    <div className="accordion-body AB">
                                                        <li className="nested-dropdpwn-items">Advertise on 9GAG</li>
                                                        <li className="nested-dropdpwn-items">Report Ads</li>
                                                        <hr className="nested-dropdpwn-hr"/>
                                                    </div>

                                                    </div>
                                                </div>
                                        </div>
                                        </li>

                                        <li>
                                        <div className="accordion" >
                                                <div>
                                                    <h2 className="accordion-header" >
                                                    <button id="ContactP" className=" accordion-button items" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne3P" aria-expanded="true" aria-controls="collapseOne" onClick={itemClicked}>
                                                    Contact
                                                    </button>
                                                    </h2>
                                                    <div id="collapseOne3P" className="accordion">
                                                    <div className="accordion-body AB">
                                                        <li className="nested-dropdpwn-items">Career</li>
                                                        <li className="nested-dropdpwn-items">Business Enquiry</li>
                                                        <hr className="nested-dropdpwn-hr"/>
                                                    </div>

                                                    </div>
                                                </div>
                                        </div>
                                    </li>

                                    <li>
                                        <p id="gagP" href="#" className="disabled">
                                        9GAG <em>&copy;</em> 2022
                                        </p>
                                    </li> 


                                    
                                </ul>
                        </div>

                        <div id='post-but-divP' className="right-component">
                                    <Link to='/addnewpost' id="post-butP" type="button" className="buttons"><img className='post-pen' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAXJJREFUSEvt1v1NwkAYBvDnJRViAthOoCPUCZQNcAM20RHcwDiBI8gIt4F1gn4cibQcPXOJNYVeP+hdQ2Lsv5D+eN57yHuEMz10Jhd/B/4Kw5uR47wB8AGwXIiHS88LjidrNXG22fhSyncAbgmKiGgxnk5ZGbcGyzB0M8dRya40vYlyIW7Lya3BCsuSZCWJXrSFlfJ1Mp+vis+MYTXei90uIM+L2vDJbPbrGcGlMw3GQiwacVuJNUViDXicC+Ebn3FNe9WkdfgzEd0bt7oBLXpzgKu2F0fQ++/UAdXiupZ3LtcJqHJi3XhPTmwbVT+gNfEQaCs8FNoID4nWwkOjtXCaJAGIrjvcTlrbW/eOSrl+FvnHkKg2cZokSxCpG0TT0ztp7VpMOX8C8NigGqPaxFvO1wTc1cBWUP2oOVcLvXp9kfKTRqPl8Zbp0AXtVw7KVSpWLAFGwBpSsny/Z7qbYl+0klitsC3g2kaMtpNJun9YTeAbfjfzH40wiiEAAAAASUVORK5CYII="/> <b className='post-text'>  Post </b>
                                    </Link>
                        </div>  
                 </div>
            </div>  
            <hr id="navbar-hrP"/>
           </div>  
            )
  }
  export default NavPost
  